import styles from "./App.module.css";
import { useContext, useState, useEffect, useReducer } from "react";
import "./App.css";
import Router from "./components/_Process Steps/Router";
import DataContext from "./components/store/data-context";
import locationIcon from "./assets/icons/location.png";

console.log("Version: 1.0.3");

function App() {
    const { closeApp, setIsOpen, isOpen } = useContext(DataContext);
    const openApp = () => {
        setIsOpen(true);
    };

    /*useEffect(() => {
        console.log(window.location.pathname);
        if (
            window.location.search === "?provjera_dostupnosti" ||
            window.location.pathname.includes("/aktivacija")
        ) {
            setIsOpen(true);
        }
    }, [window.location.search, window.location.pathname]);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isOpen]);*/

    return (
        <>
            {/*!isOpen && (
                <div className={styles[`start-button-container`]}>
                    <div className={styles[`start-button`]} onClick={openApp}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className={styles[`start-icon`]}
                        >
                            <path d="M12 2C7.5 2 4 5.48 4 9.9c0 4.79 7 11.1 7.53 11.59.3.28.64.41.97.41.33 0 .66-.13.97-.41C13 21 20 14.69 20 9.9 20 5.48 16.5 2 12 2zm0 12.6c-2.08 0-3.75-1.68-3.75-3.75S9.92 7.1 12 7.1s3.75 1.68 3.75 3.75S14.08 14.6 12 14.6z" />
                        </svg>
                        <div className={styles[`start-text`]}>
                            Provjeri Dostupnost
                        </div>
                    </div>
                </div>
            )*/}
            <Router closeApp={closeApp} />
        </>
    );
}

export default App;
